import { render, staticRenderFns } from "./TaskInfoHeader.vue?vue&type=template&id=d77308bc&scoped=true"
import script from "./TaskInfoHeader.vue?vue&type=script&lang=js"
export * from "./TaskInfoHeader.vue?vue&type=script&lang=js"
import style0 from "./TaskInfoHeader.vue?vue&type=style&index=0&id=d77308bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77308bc",
  null
  
)

export default component.exports